export default {
  // Font
  fontSize: '18px',
  fontFamily: "'Fira Sans', sans-serif",
  standoutFontFamily: "'Libre Franklin', sans-serif",
  fontWeight: 'normal',

  // Colors
  gray4: '#232323',
  gray3: '#929292',
  gray2: '#c8c8c8',
  gray1: '#f4f4f4',
  grayLightColor: '#f4f4f4',
  grayColor: '#929292',
  backgroundColor: '#3a3a3a',
  mainBackgroundColor: 'white',
  fontColor: '#232323',
  primaryColor: '#2aaae2',
  secondaryColor: '#cc1843',
  standoutColor: 'green',

  errorColor: 'red',
  successColor: 'green',

  borderRadius: '4px',

  // Grid
  grid: {
    gap: '15px',
    containerGap: '15px',
    columnGap: '15px',
  },

  breakingpoints: {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
};
